"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledTag = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

var _spacing = _interopRequireDefault(require("../../theme/spacing"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  background-color: ", ";\n  padding: ", ";\n  border-radius: 4px;\n  display: inline-flex;\n\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: transparent;\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ghostStyles = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.color;
}, function (props) {
  return props.color;
});

var StyledTag = _styledComponents["default"].div(_templateObject2(), _colors["default"].lychee[100], function (props) {
  return props.color;
}, "".concat(_spacing["default"][1], " ").concat(_spacing["default"][3]), function (props) {
  return props.ghost ? ghostStyles : '';
});

exports.StyledTag = StyledTag;
var _default = {
  StyledTag: StyledTag
};
exports["default"] = _default;